import { render, staticRenderFns } from "./AttachmentListModal.vue?vue&type=template&id=8e50c752&scoped=true"
import script from "./AttachmentListModal.vue?vue&type=script&lang=js"
export * from "./AttachmentListModal.vue?vue&type=script&lang=js"
import style0 from "./AttachmentListModal.vue?vue&type=style&index=0&id=8e50c752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e50c752",
  null
  
)

export default component.exports